import { StyleSystemProps } from '@withjoy/joykit';

const gridContainer: StyleSystemProps = {
  display: 'grid',
  gridTemplateColumns: 'repeat(12, 1fr)',
  width: '100%',
  aspectRatio: '100/40',
  gap: 5,
  minHeight: '408px',
  minWidth: '1104px',
};

export const styles = {
  gridContainer,
};
